

































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Button } from '@/pages/profile/components';
import {
  MentoringMeetingDate,
  MentoringTimeMeeting,
  MentoringMeetingStatus,
  MentoringMeetingResult,
} from './components';

@Component({
  components: {
    Button,
    MentoringMeetingDate,
    MentoringTimeMeeting,
    MentoringMeetingStatus,
    MentoringMeetingResult,
  },
})
export default class MentoringMeeting extends Vue {
  @Prop({ type: Number, default: 0 })
  readonly meetingNumber!: number;

  @Prop({ type: Object, default: () => {} })
  readonly meeting!: any;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/modal/components/meeting/MentoringMeeting.vue